import { BarLoader, ClockLoader } from "react-spinners";
import { Form } from "react-bootstrap";
import { ICONS } from "../../../common/constants/icons";

export const ImageUploadRenderer = (props) => {
  let maxSizeMB = props.size || 40;
  return (
    <div className="file-cell">
      {props.profileOg !== "" && props.progress === 0 ? (
        <>
          <Form.Label className="label-color"
            onClick={() => {
              props.handleDownload(props.selectedData, props.imageData);
            }}
          >
            {props.downloadloading === true && (
              <ClockLoader
                size={15}
                className="gridimgdownloadloader"
              />
            )}{" "}
            &nbsp;
            {props.profileOg}
          </Form.Label>
          <img
            onMouseOver={(e) => (e.currentTarget.src = ICONS.Delete)}
            onMouseOut={(e) => (e.currentTarget.src = ICONS.DeleteGray)}
            src={ICONS.DeleteGray}
            alt="edit"
            onClick={() => props.handleDelete(props.selectedData)}
          />
        </>
      ) : (
        <>
          {props.progress !== 0 ? (
            <>
              <Form.Label className="uploadingpdfname">{props.profileOg}</Form.Label>
              {props.Imgloading && (
                <BarLoader
                  height={4}
                  width={170}
                  className="gridimgloader"
                />
              )}
            </>
          ) : (
            <>
              <img htmlFor="fileInput" src={ICONS.Upload} />
              <Form.Label htmlFor={props.id} className="label-color">
                Upload File <span style={{ fontSize: "12px" }}>  Size: Max {maxSizeMB}MB</span>
              </Form.Label>
              <input
                id={props.id}
                name={props.name}
                type={props.type}
                accept={props.accept}
                hidden
                ref={props.ref}
                onChange={(a) =>
                  props.handleFile(a, props.selectedData, props.imageData)
                }
              />
            </>
          )}
        </>
      )}
    </div>
  );
};

export const QualificationDueInRenderer = (props) => {
  let row = props.selectedData.data;
  const [year, month, day] = props.selectedDate.split("-");
  const today = new Date();
  const future = new Date(year, month - 1, day);
  future.setDate(future.getDate() + Number(process.env.REACT_APP_WELDER_QUALIFICATION_DUE_IN));
  const timeDifferenceInMilliseconds = future - today;
  let result = "";

  const daysDifference = Math.ceil(
    timeDifferenceInMilliseconds / (1000 * 60 * 60 * 24)
  );

  props.setFutureDate(daysDifference);

  const monthsValue = Math.floor(props.futureDate / 30); // Assuming 30 days in a month
  const daysValue = props.futureDate % 30;

  props.setMonths(monthsValue);
  props.setDays(daysValue);

  if (monthsValue < 1 && daysValue > 0) {
    result = `${daysValue} day`;
  } else if (monthsValue >= 1) {
    result = `${monthsValue} month ${daysValue} day`;
  } else if (daysValue <= 0) {
    result = "Inactive";
  }

  props.handleResult(result);
  row.wpq_QualificationDueIn = result;
  return result;
};
